import axios from 'axios';
import * as localStorage from "../tools/storage";
import {getAccessToken} from '../api';
export const isDev = process.env.NODE_ENV === 'development' || localStorage.getItem('isdev');
export const apiServer = isDev ? 'https://api-server-3.goaffpro.com' : 'https://api2.goaffpro.com';


export function getHttpClient(){
    const headers = {
    }
    if(getAccessToken()){
       headers.Authorization = 'Bearer '+getAccessToken()
    }
    headers['x-shop'] = localStorage.getItem('x-shop') || document.location.hostname;
    return axios.create({
        baseURL:apiServer+"/v1/user",
        headers
    })
}

